const ru = {
  translation: {
    // ── Brand ─────────────────────────────────────────────────────────────────
    brand: { name: 'OnCall', tagline: 'Оповещения' },

    // ── Navigation ────────────────────────────────────────────────────────────
    nav: {
      dashboard: 'Дашборд',
      sessions: 'Смены',
      notifications: 'Уведомления',
      myPage: 'Мой профиль',
      admin: 'Админ',
      expandSidebar: 'Развернуть меню',
      collapseSidebar: 'Свернуть меню',
      openMenu: 'Открыть меню',
      viewAccount: 'Перейти в профиль',
      logout: 'Выйти',
      installApp: 'Установить приложение',
    },

    // ── Settings menu ─────────────────────────────────────────────────────────
    settings: {
      language: 'Язык',
      theme: 'Тема',
      themeDark: 'Тёмная',
      themeLight: 'Светлая',
      themeSystem: 'Системная',
    },

    // ── Login ─────────────────────────────────────────────────────────────────
    login: {
      title: 'OnCall Alert Notifier',
      subtitle: 'Внутренний инструмент управления дежурствами',
      features: {
        gmail: 'Мониторинг оповещений Gmail',
        phone: 'Звонки на телефон',
        calendar: 'Отслеживание дежурств по календарю',
        reports: 'Ежемесячные отчёты',
      },
      signIn: 'Войти через Google',
      hint: 'Войдите с помощью корпоративного аккаунта Google Workspace',
      errors: {
        access_denied: 'Вы отклонили доступ к аккаунту Google. Попробуйте ещё раз.',
        email_not_allowed: 'Ваш email не в списке разрешённых. Обратитесь к администратору.',
        state_mismatch: 'Сессия авторизации истекла или недействительна. Попробуйте ещё раз.',
        unknown: 'Произошла непредвиденная ошибка. Попробуйте ещё раз.',
      },
    },

    // ── Dashboard ─────────────────────────────────────────────────────────────
    dashboard: {
      onCallStatus: 'Статус дежурства',
      onDuty: 'На смене',
      offDuty: 'Не на смене',
      ends: 'До {{time}}',
      nextShift: 'Следующая смена',
      noneScheduled: 'Нет запланированных',
      noUpcomingShifts: 'Нет смен в ближайшие 14 дней',
      recentIncidents: 'Последние инциденты',
      noIncidents: 'Инцидентов пока нет. Наслаждайтесь тишиной!',
      activeIncidentTitle: 'Активный инцидент',
      activeIncidentStarted: 'Начало {{time}}',
      confirmIncident: 'Подтвердить',
      loadError: 'Не удалось загрузить дашборд. Бэкенд может быть недоступен.',
      table: {
        started: 'Начало',
        status: 'Статус',
        confirmed: 'Подтверждён',
        notes: 'Заметки',
        investigation: 'Расследование',
      },
    },

    // ── Incident statuses ─────────────────────────────────────────────────────
    incidentStatus: {
      ACTIVE: 'Активный',
      CONFIRMED: 'Подтверждён',
      RESOLVED: 'Решён',
      TIMEOUT: 'Таймаут',
      SILENT: 'Тихий',
      STALLED: 'Завис',
      FAILED: 'Ошибка',
    },

    // ── Sessions / Report page ────────────────────────────────────────────────
    sessions: {
      title: 'Сводка дежурств',
      me: 'Я',
      manualIncident: 'Ручной инцидент',
      manual: 'Вручную',
      investigated: 'расследовано',
      month: 'Месяц',
      exportExcel: 'Экспорт Excel',
      loadError: 'Не удалось загрузить смены за {{month}}.',
      stats: {
        totalOnCall: 'Общее время дежурств',
        paidHours: 'Оплачиваемые часы (вне {{start}}:00\u2013{{end}}:00 + обед)',
        weekendHours: 'Выходные часы',
        investigationTime: 'Время расследований',
        sessionCount_one: '{{count}} смена',
        sessionCount_few: '{{count}} смены',
        sessionCount_many: '{{count}} смен',
        sessionCount_other: '{{count}} смен',
      },
      calendar: {
        today: 'Сегодня',
        prevMonth: 'Предыдущий месяц',
        nextMonth: 'Следующий месяц',
        more_one: 'ещё +{{count}}',
        more_few: 'ещё +{{count}}',
        more_many: 'ещё +{{count}}',
        more_other: 'ещё +{{count}}',
        nothingOnDay: 'На этот день ничего не запланировано.',
        incidentCount_one: '{{count}} инцидент',
        incidentCount_few: '{{count}} инцидента',
        incidentCount_many: '{{count}} инцидентов',
        incidentCount_other: '{{count}} инцидентов',
        legend: {
          session: 'Смена',
          incident: 'Инцидент вне смены',
        },
      },
      table: {
        session: 'Смена',
        start: 'Начало',
        end: 'Конец',
        duration: 'Длительность',
        incidents: 'Инциденты',
        actions: 'Ред.',
        viewIncidents: 'Просмотр инцидентов',
        unmatchedIncident: 'Инцидент вне смены',
      },
      dialog: {
        incidentNotes: 'Заметки об инциденте',
        notes: 'Заметки',
        notesHelper: '{{count}}/300 \u2014 что произошло, что было исследовано?',
        notesCount: '{{count}}/300',
        investigationTime: 'Время расследования (мин)',
        investigationHelper: 'Время, потраченное на исследование инцидента',
        cancel: 'Отмена',
        save: 'Сохранить',
        saving: 'Сохранение\u2026',
        addIncident: 'Добавить инцидент',
        date: 'Дата',
        time: 'Время',
        creating: 'Создание\u2026',
        create: 'Создать',
        incidentsTitle: 'Инциденты',
        onCallSession: 'Смена дежурства',
        noIncidents: 'Для этой смены инциденты не зафиксированы.',
        deleteConfirm: 'Подтвердить?',
        deleteIncidentTooltip: 'Удалить инцидент',
        confirmDeletion: 'Нажмите ещё раз для подтверждения',
        editNotesTooltip: 'Редактировать заметки / время расследования',
        addIncidentBtn: 'Добавить инцидент',
        close: 'Закрыть',
      },
    },

    // ── Preferences / Notifications ───────────────────────────────────────────
    preferences: {
      loadError: 'Не удалось загрузить каналы уведомлений. Обновите страницу.',
      phoneNumbers: 'Номера телефонов',
      countOf: '{{count}} / {{max}}',
      removePhone: 'Удалить номер телефона',
      noPhones: 'Номера телефонов ещё не добавлены',
      phoneLabel: 'Номер телефона',
      phonePlaceholder: '+375291234567',
      label: 'Метка',
      labelPlaceholder: 'основной',
      sendCode: 'Отправить код',
      alreadyRegistered: 'Уже зарегистрирован',
      invalidFormat: 'Неверный формат номера',
      labelTaken: 'Метка уже используется',
      charCount: '{{count}}/20',
      codeSent: 'Код отправлен на <strong>{{number}}</strong>. Введите его ниже:',
      verificationCode: 'Код подтверждения',
      codePlaceholder: '123456',
      verify: 'Подтвердить',
      verifying: 'Проверка\u2026',
      back: 'Назад',
      invalidCode: 'Неверный код',
      resend: 'Отправить',
      resendIn: 'Отправить ({{seconds}}с)',
      sendAgain: 'Отправить снова',
      addPhone: 'Добавить номер',
      verifyFirst: 'Сначала подтвердите номер выше',
      verified: 'Подтверждён',
      pending: 'Ожидание',
      removeTooltip: 'Удалить номер',
      channelConflict: 'Невозможно удалить номер \u2014 он используется в канале уведомлений. Сначала удалите его из канала.',
      channels: 'Каналы уведомлений',
      notifEnabled: 'Уведомления включены',
      notifEnabledDesc: 'При обнаружении инцидента будут совершены звонки.',
      notifDisabled: 'Уведомления выключены',
      notifDisabledDesc: 'Звонки не будут совершаться даже при обнаружении инцидента.',
      noChannels: 'Каналы ещё не настроены',
      addChannel: 'Добавить канал',
      verifyPhoneFirst: 'Сначала подтвердите номер телефона',
      maxChannels: 'Максимум {{count}} каналов. Обратитесь к администратору для увеличения лимита.',
      saveChanges: 'Сохранить изменения',
      savedOk: 'Успешно сохранено',
      saveFailed: 'Не удалось сохранить \u2014 попробуйте ещё раз.',
      allMustHavePhone: 'Для всех каналов необходимо выбрать номер телефона.',
      duplicatePriority: 'Канал с таким номером и приоритетом {{priority}} уже существует.',
      deleteChannelTitle: 'Удалить канал',
      deleteChannelMessage: 'Удалить канал <strong>{{address}}</strong>? Это действие необратимо.',
      channel: {
        phone: 'Адрес канала',
        selectNumber: 'Выберите подтверждённый номер\u2026',
        required: 'Обязательно \u2014 выберите подтверждённый номер',
        priority: 'Приоритет (одинаковый \u2192 параллельно)',
        ringDuration: 'Длительность звонка: {{seconds}}с',
        ringMin: '15с',
        ringMax: '60с',
        maxRetries: 'Попыток (1\u20135)',
        retryInterval: 'Интервал, мин (1\u201310)',
        notConfigured: 'Не настроен',
        details: 'Приоритет {{priority}} \u00b7 {{ring}}с \u00b7 {{retries}}\u00d7{{interval}}мин',
        editTooltip: 'Редактировать канал',
        removeTooltip: 'Удалить канал',
        save: 'Сохранить',
        saving: 'Сохранение\u2026',
      },
      deletePhoneTitle: 'Удалить номер телефона',
      deletePhoneMessage: 'Удалить <strong>{{number}}</strong> ({{label}})? Это действие необратимо.',
      delete: 'Удалить',
    },

    // ── Account page ──────────────────────────────────────────────────────────
    account: {
      accountDetails: 'Данные аккаунта',
      fullName: 'Полное имя',
      email: 'Электронная почта',
      loginSecurity: 'Вход и безопасность',
      loginProvider: 'Провайдер входа',
      google: 'Google Workspace',
      microsoft: 'Microsoft 365',
      role: 'Роль',
      administrator: 'Администратор',
      user: 'Пользователь',
      calendar: 'Календарь',
      edit: 'Редактировать',
      onCallCalendar: 'Календарь дежурств',
      selectCalendars: 'Выберите из ваших Google-календарей',
      icsUrl: 'Ссылка ICS VictorOps',
      icsUrlHelp: 'Синхронизируется в ваш основной Google-календарь каждые 15 минут',
      eventTitle: 'Название события',
      eventTitlePlaceholder: 'напр. On Call',
      eventTitleHelp: 'Своё название для событий',
      eventTitleDefault: 'Сводка VictorOps',
      icsNotConfigured: 'Не настроено',
      icsUrlInvalid: 'Введите корректный URL (https://…)',
      icsUrlHost: 'Должна быть ссылка VictorOps (portal.victorops.com)',
      icsNeedsAttention: 'Синхронизация календаря приостановлена — ссылка недействительна или просрочена. Обновите ссылку ICS VictorOps и сохраните, чтобы возобновить.',
      eventColorLabel: 'Цвет событий дежурства',
      colorFilter: 'Фильтр по цвету событий',
      noFilter: 'Без фильтра \u2014 все события',
      colorHelp: 'Цвет, применяемый к синхронизированным событиям дежурства',
      timezoneSchedule: 'Часовой пояс и расписание',
      timezone: 'Часовой пояс',
      timezonePlaceholder: 'Europe/Warsaw',
      timezoneHelp: 'Часовой пояс IANA для отображения календаря и отчётов',
      officeHours: 'Рабочие часы',
      starts: 'Начало',
      ends: 'Конец',
      saveFailed: 'Не удалось сохранить. Попробуйте ещё раз.',
      logOut: 'Выйти',
      loggingOut: 'Выход\u2026',
      save: 'Сохранить',
      saving: 'Сохранение\u2026',
      cancel: 'Отмена',
      copied: 'Скопировано!',
      copy: 'Копировать',
      primaryCalendar: 'Основной календарь',
      colors: {
        Lavender: 'Лаванда',
        Sage: 'Шалфей',
        Grape: 'Виноград',
        Flamingo: 'Фламинго',
        Banana: 'Банан',
        Tangerine: 'Мандарин',
        Peacock: 'Павлин',
        Graphite: 'Графит',
        Blueberry: 'Черника',
        Basil: 'Базилик',
        Tomato: 'Томат',
      },
    },

    // ── Admin page ────────────────────────────────────────────────────────────
    admin: {
      tabs: { users: 'Пользователи', events: 'Системные события', allowlist: 'Разрешённые email' },
      users: {
        nameEmail: 'Имя / Email',
        lastSeen: 'Последний раз онлайн',
        never: 'Никогда',
        provider: 'Провайдер',
        role: 'Роль',
        notifs: 'Уведом.',
        accountCol: 'Аккаунт',
        testAlerts: 'Тест. алерты',
        limits: 'Лимиты',
        actions: 'Действия',
        user: 'Пользователь',
        admin: 'Администратор',
        deleteUser: 'Удалить пользователя',
        deleteConfirm: 'Вы уверены, что хотите удалить {{name}} ({{email}})? Это действие необратимо.',
        deleteBtn: 'Удалить',
        forceLogout: 'Разлогинить',
        forceLogoutConfirm: 'Завершить все сессии пользователя {{name}}?',
        forceLogoutBtn: 'Разлогинить',
        limitsTitle: 'Лимиты \u2014 {{name}}',
        maxPhones: 'Макс. номеров',
        maxChannels: 'Макс. каналов',
        testAlertsTooltip: 'При включении тестовые оповещения вызывают звонки как реальные инциденты',
        limitsTooltip: 'Телефоны: {{phones}} \u00b7 Каналы: {{channels}}',
      },
      events: {
        type: 'Тип события',
        allTypes: 'Все типы',
        from: 'С',
        to: 'По',
        clearDates: 'Сбросить даты',
        noEvents: 'Событий не найдено',
        forType: 'для типа {{type}}',
        selectAll: 'Выбрать все на странице',
        selected: '{{count}} выбрано',
        deleteSelected: 'Удалить выбранные',
        deleting: 'Удаление\u2026',
        page: 'Страница {{n}}',
        pageLast: 'Страница {{n}} (последняя)',
        previous: 'Назад',
        next: 'Далее',
        deleteTitle: 'Удалить события',
        deleteConfirm_one: 'Вы уверены, что хотите удалить {{count}} событие? Это действие необратимо.',
        deleteConfirm_few: 'Вы уверены, что хотите удалить {{count}} события? Это действие необратимо.',
        deleteConfirm_many: 'Вы уверены, что хотите удалить {{count}} событий? Это действие необратимо.',
        deleteConfirm_other: 'Вы уверены, что хотите удалить {{count}} событий? Это действие необратимо.',
        types: {
          RUNTIME_EXCEPTION: 'Ошибки выполнения',
          INCIDENT: 'Инциденты',
          TEST_ALERT: 'Тестовые алерты',
          SYSTEM: 'Системные',
          AUTH: 'Нарушения авторизации',
          ACCESS_DENIED: 'Отказ в доступе',
        },
      },
      allowlist: {
        addTitle: 'Добавить разрешённый email',
        hint: '',
        emailLabel: 'Email',
        emailPlaceholder: 'user@company.com',
        noteLabel: 'Заметка (необязательно)',
        add: 'Добавить',
        tableEmail: 'Email',
        tableType: 'Тип',
        tableAddedBy: 'Добавлено',
        tableAddedAt: 'Дата',
        tableNote: 'Заметка',
        editNote: 'Изменить заметку',
        saveNote: 'Сохранить заметку',
        lastEdited: 'Изменено {{time}}',
        tableRemove: 'Удалить',
        kindEmail: 'Email',
        kindWildcard: 'Wildcard',
        kindRegex: 'Regex',
        kindInvalid: 'Ошибка',
        detected: 'Определено как: {{kind}}',
        validationError: 'Укажите корректный email, wildcard (*@domain.com) или регулярное выражение',
        removeConfirm: 'Удалить {{email}} из списка?',
      },
    },

    // ── Common ────────────────────────────────────────────────────────────────
    common: {
      confirm: 'Подтвердить',
      cancel: 'Отмена',
      save: 'Сохранить',
      saving: 'Сохранение\u2026',
      delete: 'Удалить',
      close: 'Закрыть',
      by: '{{name}}',
      me: 'я',
      min: '{{count}} мин',
      user: 'Пользователь',
      primary: 'основной',
      main: 'основной',
      noDetails: 'Нет дополнительных сведений.',
      unexpectedError: 'Произошла непредвиденная ошибка',
      providerGoogle: 'Google',
      providerMicrosoft: 'Microsoft',
      conflictRetry: 'Данные были изменены в другой сессии — обновите страницу и попробуйте снова.',
    },
  },
}

export default ru
